




































import Page from '@/Page.vue';
import moment from 'moment';
import {Component, Watch} from 'vue-property-decorator';
import WorkTaskDialogItem from '../components/WorkTaskDialogItem.vue';
import WorkTaskRuleDialog from '@/libs/parties/components/WorkTaskRuleDialog.vue';
import ApiService from "@/libs/core/api-service";
import {QueryOperator} from "@/libs/Api";

@Component({
    components: {
        WorkTaskDialogItem,
        WorkTaskRuleDialog
    }
})
export default class WorkTaskDialog extends Page {

    partyId: string | null = null;
    day: string | null = null;
    dialog = false;
    valid = true;
    saving = false;
	checkedPeriod = false;
	isPeriodLocked = false;

	@Watch("partyId")
	@Watch("day")
	filtersChanged() {
		this.checkedPeriod = false;
		if (this.partyId && this.day) {
			this.checkPeriod();
		}
	}

    open () {
        this.dialog = true;
        this.partyId = null;
        this.day = moment().format("YYYY-MM-DDT00:00:00");
    }

    close () {
        this.dialog = false;
    }

    save () {
        this.$emit("add", this.partyId, this.day);
    }

	checkPeriod() {
		ApiService.api.getPartyPeriodBatch(1, 1, {
			predicates: [
				{ field: "partyId", op: QueryOperator.Eq, comparand: this.partyId! },
				{ field: "fromDate", op: QueryOperator.Lte, comparand: this.day },
				{ field: "toDate", op: QueryOperator.Gte, comparand: this.day }
			],
			orderby: []
		}).then((x: any) => {
			this.checkedPeriod = true;
			this.isPeriodLocked = x.data.returnValue.items?.firstOrDefault()?.isLocked ?? false;
		})
	}

}
